import { Footer } from "./bundles/common/footer/components/Footer";
import Header from "./bundles/common/header/components/Header";
import { ToastContainer } from "react-toastify";
import AppRoutes from "./AppRoutes";

const App = () => {
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Header />
      <main id="conteudo-principal">
        <AppRoutes />
      </main>
      <Footer />
    </>
  );
};

export default App;
